import { ELEMENT_TYPE } from "./constants";
// 把html元素转成自定义
/**
 * @param domElem HTML 对应的 DOM Element
 * @param children 子节点
 * @param editor editor 实例
 * @returns 元素数据结构，如上文的 Resume
 */
const parseHtml = (domElem, children) => {
  // 生成元素数据结构
  try {
    const qContent = fixAndParseEditorContent(
      domElem.getAttribute("data-qContent")
    );
    const aContent = fixAndParseEditorContent(
      domElem.getAttribute("data-aContent")
    );
    const myResume = {
      type: ELEMENT_TYPE,
      children: [qContent, aContent],
    };
    // const qContent = domElem.getAttribute("data-qContent");
    // const aContent = domElem.getAttribute("data-aContent");
    // const aNode = {
    //   type: "paragraph",
    //   children: [JSON.parse(aContent)],
    // };
    // const qNode = {
    //   type: "paragraph",
    //   children: [JSON.parse(qContent)],
    // };
    // const myResume = {
    //   type: ELEMENT_TYPE,
    //   children: [qNode, aNode],
    // };
    return myResume;
  } catch (error) {
    const myResume = {
      type: ELEMENT_TYPE,
      children: [{ text: "" }, { text: "" }],
    };
    return myResume;
  }
};
const fixAndParseEditorContent = (jsonString) => {
  try {
    // 解析原始JSON
    const parsedData = JSON.parse(jsonString);

    // 处理非法嵌套结构
    if (parsedData.type === "paragraph" && Array.isArray(parsedData.children)) {
      // 提取所有子段落的内容
      const flattenedChildren = [];

      parsedData.children.forEach((child) => {
        if (child.type === "paragraph" && Array.isArray(child.children)) {
          flattenedChildren.push(...child.children);
        } else {
          flattenedChildren.push(child);
        }
      });

      return {
        type: "paragraph",
        children: flattenedChildren,
      };
    }

    return parsedData;
  } catch (error) {
    console.error("解析内容失败:", error);
    return { type: "paragraph", children: [] };
  }
};
// 编辑器解析html配置
export const parseHtmlConfig = {
  selector: `div[data-w-e-type="${ELEMENT_TYPE}"]`, // CSS 选择器，匹配特定的 HTML 标签
  parseElemHtml: parseHtml,
};
